<mat-card>
  <mat-card-header
    *ngIf="fullName$ | async as fullName"
    [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null"
  >
    <!-- This must be a div or the matCardAvatar directive won't work -->
    <div matCardAvatar *ngIf="showAvatar">
      <glxy-avatar
        *ngIf="(showUnknownAvatar$ | async) === false; else unknownUserAvatar"
        [name]="fullName"
        [width]="AVATAR_WIDTH"
        [src]="(profileImageUrl$ | async) ?? ''"
      ></glxy-avatar>
    </div>
    <mat-card-title>
      <span class="title">
        <span *ngIf="fullName$ | async as fullName" class="full-name">{{ fullName }}</span>
        <span *ngIf="headerText$ | async as headerText">{{ headerText | translate }}</span>
        <ng-container *ngIf="showPrimaryAssociation">
          <ng-container *ngIf="primaryAssociation() as primaryAssociation">
            <span class="association">
              {{ 'OBJECT_TYPES.FOR_LABEL' | translate }} {{ primaryAssociation.objectType || '' | translate }}
              <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
            </span>
          </ng-container>
        </ng-container>
      </span>
    </mat-card-title>
    <mat-card-subtitle>
      <ng-container *ngIf="subtitleTemplate; then subtitleCustomTemplate; else subtitleDefaultTemplate"></ng-container>
    </mat-card-subtitle>

    <ng-content select="[crmActivityTemplateOptions]"></ng-content>
  </mat-card-header>
  <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
    <!-- align content with edge of avatar as AVATAR_WIDTH + padding of mat-card-title -->
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>

<ng-template #unknownUserAvatar>
  <crm-unknown-user-avatar [width]="AVATAR_WIDTH"></crm-unknown-user-avatar>
</ng-template>

<ng-template #subtitleDefaultTemplate>
  <p *ngIf="effectiveDate$ | async as effectiveDate" class="effective-date">
    {{ effectiveDate | date: dateFormat }}
  </p>
</ng-template>

<ng-template #subtitleCustomTemplate>
  <div class="effective-date">
    <ng-container *ngTemplateOutlet="subtitleTemplate!"></ng-container>
  </div>
</ng-template>
